import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import BuyPackagesModal from '../Components/Modals/BuyPackagesModal';
import { RootStackParamList } from '../navigator';
import { MainLayout } from '../Pages/MainLayout';

type Props = NativeStackScreenProps<RootStackParamList, 'VipSubscription'>;

const VipSubscriptionScreen: React.FC<Props> = ({ navigation }) => {
	return (
		<MainLayout>
			<BuyPackagesModal
				initialActiveTab='vip'
				onClose={() => navigation.goBack()}
				renderInline
				renderVipPage
			/>
		</MainLayout>
	);
};

export default VipSubscriptionScreen;
